module.exports = __webpack_public_path__ + "img/1440433249.32d97a0a.jpg";